import { ICompany } from './company-interfaces';

export enum ESignUpStep {
  CREATE_USER = 'create-user',
  CREATE_COMPANY = 'create-company',
  CHOOSE_PLAN = 'choose-plan',
  FINISH = 'finish',
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  whatsapp: string;
  signup_step: ESignUpStep;
  company: ICompany;
}

export interface RecoverPasswordRequestDTO {
  email: string;
}

export interface NewPasswordRequestDTO {
  token: string;
  email: string;
  password: string;
  password2: string;
}
